export function parseQuery(query: string): {[key: string]: string} {
    const ret = {};
    const urlSearchObj = new URLSearchParams(query);
    urlSearchObj.forEach((value, key) => (ret[key] = value));
    return ret;
}
